import { Typography } from '@aloft/toolkit-sui';

import { FieldPath, useFormContext } from 'react-hook-form';

import { PropertyGridForm } from '../types.ts';
import { readOnlyFieldTypographyProps } from './consts.ts';
import { PropertyGridFieldProps } from './types.ts';

export const DataSourceValueField = <T, U extends string | number>({
  columnIndex,
  field,
}: PropertyGridFieldProps<T, U>) => {
  const { fieldName, toDisplayValue } = field;

  const { watch } = useFormContext<PropertyGridForm>();

  const propertyDataFieldName: FieldPath<PropertyGridForm> = `columns.${columnIndex}.propertyData.${fieldName}`;
  const value = watch(propertyDataFieldName) as T | undefined;
  const displayValue = toDisplayValue ? toDisplayValue(value) : (value as string | undefined);

  return <Typography {...readOnlyFieldTypographyProps}>{displayValue}</Typography>;
};
